import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledCrossSVG = styled.svg<IconProps>`
  & .cls-1 {
    fill: none;
  }

  & .cls-2 {
    fill: var(--chatbot-color-primary, #404040);
  }

  &:hover,
  &.active {
    .cls-2 {
      fill: var(--du-color-primary, #128370);
      stroke: var(--du-color-primary, #128370);
    }
  }
`;

const CrossIcon: React.FC<IconProps> = ({ active }) => {
  let activeclass = active ? 'active' : undefined;
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeclass = `${activeclass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledCrossSVG
      id='Cross-Icon-SVG'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeclass}
    >
      <rect id='Margin' className='cls-1' width='32' height='32' />
      <path
        id='Path_8818'
        data-name='Path 8818'
        className='cls-2'
        d='M22,11.333,20.667,10,16,14.667,11.333,10,10,11.333,14.667,16,10,20.667,11.333,22,16,17.333,20.667,22,22,20.667,17.333,16Z'
      />
    </StyledCrossSVG>
  );
};

export default CrossIcon;
